import { AxiosResponse } from 'axios';
import { ThunkAction, ThunkDispatch as ReduxThunkDispatch } from 'redux-thunk';
import { FluxStandardAction } from 'redux-promise-middleware';
import { ApplicationState } from '../javascripts/reducers';

export enum DrawerMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type ThunkAsyncAction = { type: string; payload: Promise<any>; meta?: any };
export type ThunkSyncAction = { type: string; payload?: any; meta?: any };
export type ThunkAnyAction = ThunkAsyncAction | ThunkSyncAction;
export type ThunkAsyncDispatch = ReduxThunkDispatch<ApplicationState, undefined, ThunkAsyncAction>;
export type ThunkFlexibleDispatch = ReduxThunkDispatch<ApplicationState, undefined, ThunkAnyAction>;
export type ThunkResult<R> = ThunkAction<R, ApplicationState, undefined, ThunkAnyAction>;
export type ThunkAsyncResult = ThunkResult<Promise<void>>;
export type ThunkAxiosResult = ThunkResult<Promise<AxiosResponse>>;
export type AsyncDispatch = (action: FluxStandardAction) => Promise<any>;
export interface Indexable {
  [key: string]: any;
}
